














module.exports = {
  "de-DE.js": () => import("./de-DE.js"),
  "en-GB.js": () => import("./en-GB.js"),
  "en-US.js": () => import("./en-US.js"),
  "es-419.js": () => import("./es-419.js"),
  "es-ES.js": () => import("./es-ES.js"),
  "fr-CA.js": () => import("./fr-CA.js"),
  "fr-FR.js": () => import("./fr-FR.js"),
  "id-ID.js": () => import("./id-ID.js"),
  "it-IT.js": () => import("./it-IT.js"),
  "ja-JP.js": () => import("./ja-JP.js"),
  "nl-NL.js": () => import("./nl-NL.js"),
  "pt-BR.js": () => import("./pt-BR.js"),
  "sv-SE.js": () => import("./sv-SE.js"),
  "th-TH.js": () => import("./th-TH.js"),
  "zh-CN.js": () => import("./zh-CN.js")
}